// import React from 'react';
// import { Container, Image} from 'react-bootstrap';
export default function NotFound ()  {
    return (
        <>
            <div fluid="md" className="container d-flex flex-column align-items-center justify-content-center">
                <img src="img/notfound.png" alt="" style={{width:'50%'}} />
                <h1>Ups Yang Anda Cari Tidak ditemukan</h1>
                <p>Please check the data entered again</p>
            </div>
        </>
    );
};
